<template>
  <div class="card">
    <div class="bg-blue-light px-1 rounded pb-2">
      <TitleButton
          class="mt-1"
          btnTitle="List"
          :showBtn="true"
          :showAddNew="false"
          :title="headerTitle"
          @onClickCloseButton="navigateToListPage"
      />
    </div>

    <div class="px-2 mt-1">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Date</label>
              <input
                  class="form-control invoice-edit-input"
                  tabindex="1"
                  type="date"
                  v-model="formData.date"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Designation</label>
              <v-select
                  placeholder="Select Designation"
                  v-model="formData.designation_id"
                  :options="designationList"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Employee Category</label>
              <v-select
                  placeholder="Select Category"
                  v-model="formData.employee_category_id"
                  :options="employeeCategoryList"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="align-middle">Department</label>
              <v-select
                  placeholder="Select Department"
                  v-model="formData.department_id"
                  :options="departmentList"
                  label="name"
                  :reduce="name => name.id"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Job Location</label>
              <AsyncSelect
                  placeholder="Select Job Location"
                  v-model="area"
                  :api-service="fetchAreaList"
                  label="name"
              />
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Estimated Join Date</label>
              <input
                  class="form-control invoice-edit-input"
                  tabindex="1"
                  type="date"
                  v-model="formData.date_of_joining"
              >
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Probation Period</label>
              <input
                  class="form-control invoice-edit-input"
                  tabindex="1"
                  type="number"
                  v-model="formData.probation_period"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
            <div class="d-flex align-items-center justify-content-between filter-label">
                <label for="colFormLabel" class="col-form-label">Reporting To: </label>
                <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
              </div>

              <AsyncSelect
                  placeholder="Select Supervisor"
                  v-model="supervisor"
                  :api-service="fetchContactProfiles"
                  :additional-query="additionalContactOption"
              />
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Salary Type</label>
              <input
                  class="form-control invoice-edit-input text-capitalize"
                  tabindex="1"
                  type="text"
                  disabled
                  v-model="salaryStructureFormData.salary_type"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Salary Grade Scale</label>
              <input
                  class="form-control invoice-edit-input text-capitalize"
                  tabindex="1"
                  type="text"
                  disabled
                  v-model="salaryStructureGradeData.salary_grade_scale_amount"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <label class="form-label">Gross Salary</label>
              <input
                  class="form-control invoice-edit-input"
                  tabindex="1"
                  type="text"
                  disabled
                  v-model="salaryStructureGradeData.gross_total"
              >
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <button class="btn btn-primary btn-sm"
                      @click="openAddEditModal(formData.contact_profile_id)"
                      style="cursor: pointer"
              >
                Add Salary Structure
              </button>
            </div>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label for="colFormLabel" class="col-form-label">Job Description: </label>
                <AsyncSelect
                    placeholder="Select Job description"
                    v-model="selectedJobDescription"
                    :api-service="fetchActivitySetupEndpoint"
                    label="name"
                    :reduce="name => name.name"
                />
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <button class="btn btn-sm btn-primary mt-2" @click="addJobDescription">
                    <i class="fa fa-plus"></i>
                </button>
              </div>

              <div v-if="jobDescription && jobDescription.length" class="col-12 mt-4">
                <ul class="list-group">
                  <li
                      v-for="(item, index) in jobDescription"
                      :key="index"
                      class="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <template v-if="editingJdIndex === index">
                      <div style="width: 100%">
                        <input
                            v-model="editingJdText"
                            class="form-control form-control-sm"
                            @blur="saveEdit(index)"
                            @keyup.enter="saveEdit(index)"
                            autofocus
                        />
                      </div>
                    </template>

                    <template v-else>
                      <span @click="startEdit(index, item)" style="cursor: pointer;">
                        {{ item }}
                      </span>
                      <button class="btn btn-sm btn-danger" @click="removeDescription(index)"><i class="fa fa-trash"></i></button>
                    </template>
                  </li>
                </ul>
              </div>

              <div class="row pt-3" v-if="isAcceptance">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Effective Date</label>
                <input
                    class="form-control"
                    tabindex="1"
                    type="date"
                    v-model="formData.effective_date"
                >
              </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                  <label class="form-label">Remarks</label>
                  <input
                      class="form-control invoice-edit-input text-capitalize"
                      tabindex="1"
                      type="text"
                      v-model="formData.remarks"
                  >
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-4">
                <label class="form-label">Attachment</label>
                  <BlobFileViewer :attachments="formData.attachments" />
                  <FileUpload
                      :is-drag-active="true"
                      button-text="Upload Documents"
                      v-model="formData.attachments"
                  >
                  </FileUpload>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2 d-flex justify-content-start justify-content-sm-center px-2 gap-1 flex-wrap pb-2">
      <hr class="hr-full-width mb-1">
      <span v-if="isAcceptance">
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="acceptanceAppointment()"
                class="btn btn-primary me-1">
          Accept Appointment
        </button>
      </span>
      <span v-else>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP()"
                class="btn btn-primary me-1">
          Save
        </button>
        <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="saveAP(false)"
                class="btn btn-primary">Save & New
        </button>
      </span>
      <button @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
    </div>

    <ContactDropdownFilter
        v-if="store.state.isModalOpenThree"
        @onSearchContact="onSearchContact"
        :companyRoles="companyRoles"
        :isFilterable="true"
        :roleSlug="'employee'"
    />

    <AddSalaryStructureModal
        v-if="store.state.isModalOpenTwo"
        :formData="salaryStructureFormData"
        :salaryStructureData="salaryStructureData"
        :salaryStructureGradeData="salaryStructureGradeData"
        @submitted="handleSalaryStructureSubmit"
    />

    <GlobalLoader/>
  </div>
</template>
<script setup>
import {computed, inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from "vue-router";
import TitleButton from '@/components/atom/TitleButton'
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import GlobalLoader from "@/components/atom/GlobalLoader.vue";
import {useStore} from "vuex";
import handleDepartments from "@/services/modules/procurement/organization-settings/department";
import handleDesignation from "@/services/modules/procurement/organization-settings/designation";
import handleHospital from '@/services/modules/hospital'
import handleCrm from '@/services/modules/crm/crm'
import handleDropDowns from '@/services/modules/dropdowns'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleChartAccount from '@/services/modules/chartAccount'
import ContactDropdownFilter from '@/components/atom/Contact/ContactDropdownFilter.vue'
import handleRole from "@/services/modules/role";
import handleContact from "@/services/modules/contact";
import handleCompanyContact from "@/services/modules/companyContact";
import AddSalaryStructureModal from "@/components/molecule/company/hrm-payroll/salary-structures/AddSalaryStructureModal";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import { handleAttachments } from '@/services/utils/global';

const store = useStore();
const router = useRouter()
const route = useRoute()
const showError = inject('showError');
const showSuccess = inject('showSuccess')
const companyId = computed(() => {
  return route.params.companyId
})
const salaryStructureData = ref([]);
const salaryStructureGradeData = ref({
  grade_number: null,
  grade_serial: null,
  scale_amount: null,
  scale_id: null,
});
const salaryStructureFormData = ref({
  contact_profile_id: null,
  effective_date: null,
  salary_type: null,
  salary_grade_scale_id: null,
  pay_heads:[]
})

let isAcceptance = ref(false)
let appointmentEditData = ref({})
const selectedJobDescription = ref(null)
const jobDescription = ref([])
const editingJdIndex = ref(null)
const editingJdText = ref('')
let loader =ref(false)
let remarks =ref('')
let saveButtonLoader = ref(false)
let saveNewButtonLoader = ref(false)
let isCreate = ref(true)
let headerTitle = ref("Add Offer Letter")
let departmentList = ref([])
const area = ref(null);
const status = ref([]);
const designationList = ref([]);
let employeeCategoryList = ref([])
let salaryGradeData = ref([])
let supervisor = ref(null)
const additionalContactOption = ref({
  roles: 'employee',
  status: 'active'
});
const companyRoles = ref(null);
let jobAppointmentData = {}
let formData = ref({
  company_id: companyId,
  contact_profile_id:'',
  job_application_id:'',
  date:'',
  designation_id:'',
  department_id:'',
  employee_category_id:'',
  salary_grade_scale_id:'',
  area_id:'',
  type:'',
  date_of_joining:'',
  supervisor_contact_profile_id:'',
  salary_type:'',
  salary_grade_serial:'',
  probation_period:'',
  gross_salary:'',
  job_description:'',
  effective_date: null,
  remarks: null,
  attachments:[]
})

function navigateToListPage() {
  delete route.query.jobApplicationId;
  delete route.query.type;
  delete route.query.appointmentId;
  router.push({name: `appointment`, params: route.params, query: route.query});
}
const { fetchDepartmentList } = handleDepartments()
const { fetchDesignationList } = handleDesignation()
const { fetchAreaList } = handleCrm();
const { fetchNoteMasterList } = handleHospital()
const { fetchHome } = handleChartAccount()
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchContactProfiles } = handleContact();
const { fetchActivitySetupEndpoint } = handleDropDowns();
const { storeAdditionalContactItems } = handleCompanyContact();
const {
  fetchSalaryGradeScale,
  createAppointment,
  fetchSingleJobApplication,
  getEmployeeSalaryStructure,
  fetchSingleAppointment,
  fetchSingleOfferLetter,
  updateAppointment,
  updateAppointmentAcceptance
} = handleHrPayroll()

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  supervisor.value = contact
}

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${route.params.companyId}&roles=employee`);
  if (res.status) {
    companyRoles.value = res.data
  }
}

const addJobDescription = () => {
  if (!selectedJobDescription.value) {
    showError("Please Select JD")
    return
  }

  if (!Array.isArray(jobDescription.value)) {
    jobDescription.value = []
  }

  const exists = jobDescription.value.some(j => j === selectedJobDescription.value)
  if (exists) {
    showError("Already added JD")
    return
  }
  
  jobDescription.value.push(selectedJobDescription.value)
  selectedJobDescription.value = null
}

const startEdit = (index, item) => {
  editingJdIndex.value = index
  editingJdText.value = item
}

const saveEdit = (index) => {
  if (editingJdText.value.trim()) {
    jobDescription.value[index] = editingJdText.value.trim()
  }
  editingJdIndex.value = null
  editingJdText.value = ''
}

const removeDescription = (index) => {
  jobDescription.value.splice(index, 1)
}

const openAddEditModal = (contactProfileId) => {
  getEmployeeStructureData(contactProfileId)
  store.state.isModalOpenTwo = true
}

const getEmployeeStructureData = (contactProfileId) => {
  salaryStructureFormData.value.contact_profile_id = contactProfileId
  let query = getQuery()
  query += '&contact_profile_id=' + contactProfileId
  salaryStructureData.value = []
  getEmployeeSalaryStructure(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data[0]
    salaryStructureFormData.value.effective_date = data.effective_date;
    salaryStructureFormData.value.salary_type = data.salary_type
    salaryStructureFormData.value.salary_grade_scale_id = data.salary_grade_scale_id;
    salaryStructureGradeData.value.grade_number = data.grade_number;
    salaryStructureGradeData.value.grade_serial = data.grade_serial;
    salaryStructureGradeData.value.scale_amount = data.scale_amount;
    salaryStructureGradeData.value.scale_id = data.salary_grade_scale_id;
    salaryStructureGradeData.value.gross_total = data.gross_total;
    salaryStructureGradeData.value.salary_grade_scale_amount =  data.grade_number + '(' + data.scale_amount + ')';

    salaryStructureData.value = res.data;
  });
}

function saveAP(redirect = true) {
  loader.value = true
  saveButtonLoader.value = true
  if (isCreate.value) {
    handleSubmit(redirect);
  } else {
    handleUpdate(redirect);
  }
}

function handleSubmit(redirect) {
  jobAppointmentData.company_id  = formData.value.company_id;
  jobAppointmentData.contact_profile_id = formData.value.contact_profile_id;
  jobAppointmentData.job_application_id = formData.value.job_application_id;
  jobAppointmentData.date = formData.value.date;
  jobAppointmentData.designation_id = formData.value.designation_id;
  jobAppointmentData.employee_category_id = formData.value.employee_category_id;
  jobAppointmentData.department_id = formData.value.department_id;
  jobAppointmentData.area_id = area.value ? area.value.id : null;
  jobAppointmentData.type = formData.value.type;
  jobAppointmentData.date_of_joining = formData.value.date_of_joining;
  jobAppointmentData.supervisor_contact_profile_id = supervisor.value ? supervisor.value.id : null
  jobAppointmentData.probation_period = formData.value.probation_period;
  jobAppointmentData.gross_salary = salaryStructureGradeData.value.gross_total;
  jobAppointmentData.salary_type = salaryStructureFormData.value.salary_type;
  jobAppointmentData.salary_grade_scale_id = salaryStructureFormData.value.salary_grade_scale_id;
  jobAppointmentData.job_description = jobDescription.value;
  createAP(redirect);
}

function handleUpdate(redirect) {
  jobAppointmentData.id = formData.value.id;
  jobAppointmentData.company_id  = formData.value.company_id;
  jobAppointmentData.contact_profile_id  = formData.value.contact_profile_id;
  jobAppointmentData.job_application_id  = formData.value.job_application_id;
  jobAppointmentData.employee_category_id  = formData.value.employee_category_id;
  jobAppointmentData.department_id  = formData.value.department_id;
  jobAppointmentData.designation_id  = formData.value.designation_id;
  jobAppointmentData.date_of_joining  = formData.value.date_of_joining;
  jobAppointmentData.probation_period  = formData.value.probation_period;
  jobAppointmentData.type  = formData.value.type;
  jobAppointmentData.date  = formData.value.date;
  jobAppointmentData.gross_salary = salaryStructureGradeData.value.gross_total;
  jobAppointmentData.salary_type = salaryStructureFormData.value.salary_type;
  jobAppointmentData.supervisor_contact_profile_id = supervisor.value ? supervisor.value.id : null;
  jobAppointmentData.salary_grade_scale_id = salaryStructureFormData.value.salary_grade_scale_id;
  jobAppointmentData.area_id = area.value ? area.value.id : null;
  jobAppointmentData.job_description = jobDescription.value;
  updateAPData(redirect);
}

function updateAPData(redirect = true) {
  updateAppointment(jobAppointmentData, jobAppointmentData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        if (jobAppointmentData.supervisor_contact_profile_id){
          saveAdditionalContactItems(jobAppointmentData.contact_profile_id, { supervisor: jobAppointmentData.supervisor_contact_profile_id  }, getQuery())
        }
        showSuccess(res.message);
        if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loader.value = false
    saveButtonLoader.value = false
  })
}

const handleSalaryStructureSubmit = () => {
  getEmployeeStructureData(formData.value.contact_profile_id)
};

const saveAdditionalContactItems = async (contactId, keys, getQuery) => {
  await storeAdditionalContactItems(contactId, keys, getQuery).then(res => {
    loader.value = false
    if (!res.status) {
      return showError(res.message)
    } 
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loader.value = false
  })
}

function acceptanceAppointment() {
  loader.value = true
  saveButtonLoader.value = true

  jobAppointmentData.id = formData.value.id;
  jobAppointmentData.company_id  = formData.value.company_id;
  jobAppointmentData.contact_profile_id  = formData.value.contact_profile_id;
  jobAppointmentData.job_application_id  = formData.value.job_application_id;
  jobAppointmentData.employee_category_id  = formData.value.employee_category_id;
  jobAppointmentData.department_id  = formData.value.department_id;
  jobAppointmentData.designation_id  = formData.value.designation_id;
  jobAppointmentData.date_of_joining  = formData.value.date_of_joining;
  jobAppointmentData.probation_period  = formData.value.probation_period;
  jobAppointmentData.type  = formData.value.type;
  jobAppointmentData.is_acceptance  = true;
  jobAppointmentData.date  = formData.value.date;
  jobAppointmentData.effective_date  = formData.value.effective_date;
  jobAppointmentData.remarks  = formData.value.remarks;
  jobAppointmentData.gross_salary = salaryStructureGradeData.value.gross_total;
  jobAppointmentData.salary_type = salaryStructureFormData.value.salary_type;
  jobAppointmentData.supervisor_contact_profile_id = supervisor.value ? supervisor.value.id : null;
  jobAppointmentData.salary_grade_scale_id = salaryStructureFormData.value.salary_grade_scale_id;
  jobAppointmentData.area_id = area.value ? area.value.id : null;
  jobAppointmentData.job_description = jobDescription.value;

  const form = new FormData();
  Object.entries(jobAppointmentData).forEach(([key, value]) => {
    Array.isArray(value)
        ? value.forEach((item, i) => form.append(`${key}[${i}]`, item))
        : form.append(key, value !== null ? value : '');
  });

  const attachments = formData.value.attachments;
  if (attachments && attachments.length) {
    handleAttachments(form, attachments);
  }

  updateAppointmentAcceptance(form, jobAppointmentData.id, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        if (jobAppointmentData.supervisor_contact_profile_id){
          saveAdditionalContactItems(
              jobAppointmentData.contact_profile_id,
              { supervisor: jobAppointmentData.supervisor_contact_profile_id  },
              getQuery()
          )
        }
        showSuccess(res.message);
        navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
    loader.value = false
    saveButtonLoader.value = false
  })
}

const getDesignationList = async () => {
  let query = getQuery();
  designationList.value = []

  await fetchDesignationList(query).then(res => {
    if (!res.status){
      designationList.value = []
      return
    }
    designationList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

function createAP(redirect = true) {
  createAppointment(jobAppointmentData, getQuery())
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        if (jobAppointmentData.supervisor_contact_profile_id){
          saveAdditionalContactItems(jobAppointmentData.contact_profile_id, { supervisor: jobAppointmentData.supervisor_contact_profile_id  }, getQuery())
        }
        showSuccess(res.message)
        if (redirect) navigateToListPage()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        loader.value = false
        saveButtonLoader.value = false
      })
}

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const getDepartmentList = async () => {
  let query = getQuery();
  departmentList.value = []

  await fetchDepartmentList(query).then(res => {
    if (!res.status){
      departmentList.value = []
      return
    }
    departmentList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getEmployeeCategoryList = async () => {
  let query = getQuery();
  query += '&is_all=true&status=active&note_type=employee_category'
  employeeCategoryList.value = []

  await fetchNoteMasterList(query).then(res => {
    if (!res.status){
      employeeCategoryList.value = []
      return
    }
    employeeCategoryList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const getSalaryGrade = async () => {
  const query = getQuery();
  salaryGradeData.value = []

  await fetchSalaryGradeScale(query).then(res => {
    if (!res.status){
      return
    }
    salaryGradeData.value = res.data.data;
  }).catch(err => {
    console.log(err)
  })
}

function setFormData() {
  headerTitle.value = "Update Offer Letter";
  if (route.query.type == 'appointment_letter'){
    headerTitle.value = "Update Appointment Letter";
  }
  if (route.query.type == 'acceptance'){
    headerTitle.value = "Acceptance Appointment Letter";
    isAcceptance.value = true;
  }
  formData.value.id =  appointmentEditData.value.id;
  formData.value.contact_profile_id = appointmentEditData.value.contact_profile_id;
  formData.value.job_application_id = appointmentEditData.value.job_application_id;
  formData.value.employee_category_id = appointmentEditData.value.employee_category_id;
  formData.value.department_id = appointmentEditData.value.department_id;
  formData.value.designation_id = appointmentEditData.value.designation_id;
  formData.value.date_of_joining = appointmentEditData.value.date_of_joining;
  formData.value.date = appointmentEditData.value.date;
  formData.value.type = appointmentEditData.value.type;
  formData.value.probation_period = appointmentEditData.value.probation_period;
  formData.value.job_description = appointmentEditData.value.job_description;
  formData.value.gross_salary = appointmentEditData.value.gross_salary;
  formData.value.effective_date = appointmentEditData.value.effective_date;
  formData.value.attachments = appointmentEditData.value.attachments;
  jobDescription.value = appointmentEditData.value.job_description;

  salaryStructureFormData.value.salary_type =  appointmentEditData.value.salary_type;
  salaryStructureFormData.value.salary_grade_scale_id = appointmentEditData.value.salary_grade_scale_id;
  salaryStructureGradeData.value.gross_total = appointmentEditData.value.gross_salary;
  salaryStructureGradeData.value.salary_grade_scale_amount =  appointmentEditData.value.grade_number + '(' + appointmentEditData.value.scale_amount + ')';

  area.value = {
    id: appointmentEditData.value.area_id,
    name: appointmentEditData.value.area_name
  }
  supervisor.value = {
    id: appointmentEditData.value.supervisor_contact_profile_id,
    name: appointmentEditData.value.supervisor_name
  }
}

function setOfferLetterFormData() {
  if (route.query.type != 'appointment_letter'){
    return
  }
  formData.value.contact_profile_id = appointmentEditData.value.contact_profile_id;
  formData.value.job_application_id = appointmentEditData.value.job_application_id;
  formData.value.employee_category_id = appointmentEditData.value.employee_category_id;
  formData.value.department_id = appointmentEditData.value.department_id;
  formData.value.designation_id = appointmentEditData.value.designation_id;
  formData.value.date_of_joining = appointmentEditData.value.date_of_joining;
  formData.value.date = appointmentEditData.value.date;
  formData.value.probation_period = appointmentEditData.value.probation_period;
  formData.value.job_description = appointmentEditData.value.job_description;
  formData.value.gross_salary = appointmentEditData.value.gross_salary;
  formData.value.effective_date = appointmentEditData.value.effective_date;
  jobDescription.value = appointmentEditData.value.job_description;

  salaryStructureFormData.value.salary_type =  appointmentEditData.value.salary_type;
  salaryStructureFormData.value.salary_grade_scale_id = appointmentEditData.value.salary_grade_scale_id;
  salaryStructureGradeData.value.gross_total = appointmentEditData.value.gross_salary;
  salaryStructureGradeData.value.salary_grade_scale_amount =  appointmentEditData.value.grade_number + '(' + appointmentEditData.value.scale_amount + ')';

  area.value = {
    id: appointmentEditData.value.area_id,
    name: appointmentEditData.value.area_name
  }
  supervisor.value = {
    id: appointmentEditData.value.supervisor_contact_profile_id,
    name: appointmentEditData.value.supervisor_name
  }
}

function onPageReload() {
  loader.value=true
  Promise.all([
    getDepartmentList(),
    getDesignationList(),
    getEmployeeCategoryList(),
    getSalaryGrade(),
  ]).finally(() => {
    loader.value = false
  })

  formData.value.date =  new Date().toISOString().split('T')[0]
  formData.value.joining_date =  new Date().toISOString().split('T')[0]
  if(route.query.type && route.query.type !== '' && route.query.type !== undefined) {
    formData.value.type = route.query.type
    if (route.query.type == 'appointment_letter'){
      headerTitle.value = "Add Appointment Letter";
    }
  }

  if(route.query.appointmentId && route.query.appointmentId !== '' && route.query.appointmentId !== undefined) {
    isCreate.value = false;
    const req = fetchSingleAppointment(route.query.appointmentId, getQuery());
    req.then(res => {
      appointmentEditData.value = res.data;
      setFormData();
    });
  }

  if(route.query.jobApplicationId && route.query.jobApplicationId !== '' && route.query.jobApplicationId !== undefined && isCreate.value == true){
    const req = fetchSingleJobApplication(route.query.jobApplicationId, getQuery());
    req.then(res => {
      let response = res.data;
      formData.value.contact_profile_id = response.contact_profile_id
      formData.value.job_application_id = response.id
      getEmployeeStructureData(response.contact_profile_id)
    });

    const offerLetter = fetchSingleOfferLetter(route.query.jobApplicationId, getQuery());
    offerLetter.then(res => {
      appointmentEditData.value = res.data;
      setOfferLetterFormData();
    });
  }
}

onMounted(() => {
  onPageReload();
  getCompanyRoles()
})
</script>